import { ReduxModule } from '../../BaseAppProvider/BaseAppProvider';
import { globalErrorReducer } from './reducers';

export const getGlobalErrorModule = (): ReduxModule => ({
  id: 'GlobalError',
  reducerMap: {
    globalError: globalErrorReducer
  }
});
